import {
  initialState,
  Actions,
  State,
  NEW_CONTENT,
  NEW_CONTENT_SUCCESS,
  NEW_CONTENT_ERROR,
  RESET_NEW_CONTENT,
} from '../../types/content/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_CONTENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_CONTENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_CONTENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_CONTENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
